// src/pages/Home.js
import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { useTranslation } from "../hooks/useTranslation";
import Hero from "../components/Hero";
import VideoPlayer from "../components/VideoPlayer";
import { Content } from "../components/Content";
import { FloatingButton } from "../components/FloatingButton";

const getJson = async () => {
  // const response = await fetch("json/winners-example.json");
  const response = await fetch("../bingo/json/winners.json?t=" + Date.now());
  const output = await response.json();
  // waits until the request completes...

  return output;
};

const Home = () => {
  const { setLanguageFromURL } = useTranslation();
  const { lang } = useParams();
  const [output, setOutput] = useState(null);

  useEffect(() => {
    getJson().then((data) => {
      setOutput(data);
    });
  }, []);

  useEffect(() => {
    if (lang) {
      setLanguageFromURL(lang);
    }
  }, [lang, setLanguageFromURL]);

  return (
    <div className={`home-page ${"lang-" + lang}`}>
      <Hero lang={lang} />

      {lang !== "ru" ? (
        <div className="content-wrapper">
          <Content className="sloganSection">
            <FloatingButton href="https://www.eestiloto.ee/et/bingoloto/?quicktipp=2" />
            <h2>Bingo loto saab 30-aastaseks!</h2>
            <p className="slogan">
              Sünnipäeva puhul osalevad{" "}
              <strong>
                kõik veebruaris ostetud vähemalt 2 väljaga piletid
              </strong>{" "}
              automaatselt lisaloosis.
            </p>
            <p className="slogan bigger">
              {" "}
              Loosi läheb <span>30 × 1000&nbsp;€</span>
              <br />
            </p>
            <p className="middle" style={{ margin: "0 auto" }}>
              <span>✓ Võita võib ühe või ka mitu 1000-eurost võitu. </span>
              <span>
                ✓ Ostetud pilet osaleb automaatselt loosimises, eraldi
                registreerida pole vaja
              </span>
              <span>✓ Mida rohkem pileteid, seda rohkem võimalusi</span>
            </p>
            <p className="slogan">
              Lisaloosimine toimub 2.&nbsp;märtsil ja võitjad kuulutame välja
              3.&nbsp;märtsil!
            </p>
          </Content>
          <Content>
            <h2>Võidud</h2>
            <div className="bingoGrid">
              {output ? (
                <>
                  {output["winners"] &&
                    output["winners"].map((ticket, key) => (
                      <div className="winner-ticket" key={key}>
                        <span className="amount">1000&nbsp;€</span>

                        <span className="ticket-id">{ticket.id_nr}</span>

                        <span className="ticket-type">{ticket.type}</span>
                      </div>
                    ))}
                </>
              ) : (
                <p></p>
              )}
            </div>
          </Content>
        </div>
      ) : (
        <div className="content-wrapper">
          <Content className="sloganSection">
            <FloatingButton href="https://www.eestiloto.ee/ru/bingoloto/?quicktipp=2" />
            <h2>Bingo loto исполняется 30 лет!</h2>
            <p className="slogan">
              В честь дня рождения все билеты с минимум 2 полями, купленные в
              феврале, автоматически участвуют в дополнительном розыгрыше.
            </p>
            <p className="slogan bigger">
              {" "}
              На кону <span>30 × 1000&nbsp;€!</span>
              <br />
            </p>
            <p className="middle" style={{ margin: "0 auto" }}>
              <span>✓ Можно выиграть один или несколько призов по 1000 €.</span>
              <span>
                ✓ Купленный билет участвует в розыгрыше автоматически —
                отдельная регистрация не требуется.
              </span>
              <span>✓ Чем больше билетов, тем больше шансов.</span>
            </p>
            <p className="slogan">
              Розыгрыш состоится 2&nbsp;марта, а победителей объявим
              3&nbsp;марта!
            </p>
          </Content>
          <Content>
            <h2>Победители</h2>
            <div className="bingoGrid">
              {output ? (
                <>
                  {output["winners"] &&
                    output["winners"].map((ticket, key) => (
                      <div className="winner-ticket" key={key}>
                        <span className="amount">1000&nbsp;€</span>

                        <span className="ticket-id">{ticket.id_nr}</span>

                        <span className="ticket-type">{ticket.type}</span>
                      </div>
                    ))}
                </>
              ) : (
                <p></p>
              )}
            </div>
          </Content>
        </div>
      )}
    </div>
  );
};

export default Home;
